import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface ConfirmDocsOverrideDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Sentence describing what documentation is missing. */
  message: string;
  /** Every blocker the admin override will waive (docs, eligibility, OOS). */
  reasons?: string[];
  onConfirm: () => void;
}

/**
 * Admin-only override for Document Confirm Gating. Non-admins are blocked
 * outright; admins get this acknowledgement step before the order is
 * confirmed without its required billing documentation.
 */
export function ConfirmDocsOverrideDialog({
  open,
  onOpenChange,
  message,
  reasons = [],
  onConfirm,
}: ConfirmDocsOverrideDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Override and confirm this order?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2">
              {reasons.length > 0 ? (
                <ul className="list-disc pl-4 space-y-0.5">
                  {reasons.map((r) => (
                    <li key={r}>{r}</li>
                  ))}
                </ul>
              ) : (
                message && <p>{message}</p>
              )}
              <p>
                As an admin you can proceed anyway. The override is recorded in
                the order's history. Any missing documentation should be uploaded
                as soon as possible.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Confirm anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}